import { SpinnerSimple } from 'src/v2/commonComponents/SpinnerSimple';
import { PanelHeader } from '../PanelHeader';
import styles from './LoadingPanel.module.scss';
import cn from 'classnames';

interface LoadingPanelProps {
  onClose: () => void;
  title?: string;
  classname?: string;
}

export const LoadingPanel = ({
  onClose,
  title,
  classname,
}: LoadingPanelProps) => {
  return (
    <div className={cn(styles.root, classname)}>
      <PanelHeader onClose={onClose} title={title} />

      <div className={styles.loadingContainer}>
        <div>
          <SpinnerSimple className={styles.loading} />
          <span
            className={styles.loadingTitle}
            data-e2e="loading-payment-spinner"
          >
            Loading payment options…
          </span>
        </div>
      </div>
    </div>
  );
};
